export default __webpack_public_path__ + "static/media/bsl-airport.60bcb10c.webp";